<template>
  <div class="ApartmentManagement">
    <el-form :inline="true" :model="searchForm" @keyup.enter.native="getDataList()">
      <el-form-item label="产品名称">
        <el-input v-model="searchForm.productName" placeholder="产品名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button icon="el-icon-search" size="small" type="primary" @click="getDataList()">搜索
        </el-button>
        <el-button icon="el-icon-delete" size="small" plain type="primary" @click="reset()">清空
        </el-button>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-button icon="el-icon-plus" size="small" type="primary" @click="openModifyDialog()">添加产品
          </el-button>
        </el-col>
      </el-row>
    </el-form>


    <el-table class="dataTable" v-loading="dataListLoading" :data="dataList"
      :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border>
      <el-table-column label="ID" prop="id">
      </el-table-column>

      <el-table-column label="productName" prop="productName">
      </el-table-column>

      <el-table-column label="productModel" prop="productModel">
      </el-table-column>

      <el-table-column label="productCode" prop="productCode">
      </el-table-column>

      <el-table-column label="createdTime" prop="createdTime">
      </el-table-column>

    </el-table>


    <!-- 新增&修改公寓信息 -->
    <el-dialog :title="modifyForm.id ? '修改产品信息' : '添加产品'" :visible.sync="modifyDialog" width="40%"
      :before-close="cancelModifyDialog">
      <el-form class="modifyForm" ref="modifyForm" :model="modifyForm" :rules="modifyRule" label-width="40%">
        <el-form-item label="productName" prop="productName">
          <el-input style="width: 200px;" v-model="modifyForm.productName" placeholder="请输入productName"
            @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
        <el-form-item label="productModel" prop="productModel">
          <el-input style="width: 200px;" v-model="modifyForm.productModel" placeholder="请输入productModel"
            @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary" @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import '../assets/css/ApartmentManagement.css'
  export default {
    data() {
      return {
        searchForm: {},
        dataListLoading: false,
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 1,
        modifyDialog: false,
        modifyForm: {},
        detailDialog: false,
        detailForm: {},
        modifyRule: {
          productName: [{
            required: true,
            message: 'productName不能为空',
            trigger: 'blur'
          }, ],
          productModel: [{
            required: true,
            message: 'productModel不能为空',
            trigger: 'blur'
          }, ]
        },
      }
    },

    created() {
      let self = this;
      self.getDataList();
    },
    methods: {
      // 清空条件
      reset() {
        let self = this
        Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
      },

      getDataList() {
        let formdata = {
          tenantCode: sessionStorage.getItem('tenantCode'),
        }
        let self = this;
        self.$axios
          ._getProductList(formdata)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.dataList = datas.data.content
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          })
        self.dataListLoading = false
      },


      // 打开 新增&修改弹窗
      openModifyDialog: function() {
        this.modifyDialog = true
      },
      // 关闭 新增&修改弹窗
      cancelModifyDialog: function() {
        let self = this

        Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
        self.$refs.modifyForm.resetFields()
        self.modifyDialog = false
      },

      // 新增&修改
      modifyHandle: function() {

        let self = this
        if (!self.modifyForm.productModel || !self.modifyForm.productName) {
          self.$message.error('请输入有效产品信息')
          return;
        }

        let param = new FormData()
        param.append('productName', self.modifyForm.productName)
        param.append('productModel', self.modifyForm.productModel)
        param.append('tenantCode', sessionStorage.getItem('tenantCode'))

        console.log('param:', param);
        self.$axios
          ._addDevice(param)
          .then((res) => {
            console.log('add.device:',res)
            const datas = res.data
            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList()
              self.$message.success('添加成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })

      },

    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/ProductManagement.vue